import { useEffect } from "react";

/**
 * Lightweight head manager — sets <title>, meta tags, canonical, JSON-LD.
 * Used by SEO programmatic pages. Avoids react-helmet-async dependency.
 */
export const useSeoHead = ({ title, description, canonical, ogImage, jsonLd, robots = "index,follow" }) => {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    setMeta("robots", robots);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    if (ogImage) setMeta("og:image", ogImage, "property");
    if (canonical) setLink("canonical", canonical);

    let ldEl = document.getElementById("seo-page-jsonld");
    if (jsonLd) {
      if (!ldEl) {
        ldEl = document.createElement("script");
        ldEl.id = "seo-page-jsonld";
        ldEl.type = "application/ld+json";
        document.head.appendChild(ldEl);
      }
      ldEl.text = JSON.stringify(jsonLd);
    } else if (ldEl) {
      ldEl.remove();
    }

    return () => {
      const el = document.getElementById("seo-page-jsonld");
      if (el) el.remove();
    };
  }, [title, description, canonical, ogImage, robots, JSON.stringify(jsonLd)]); // eslint-disable-line react-hooks/exhaustive-deps
};

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};
